const chatMatches = a => b => {
	if (a === b) return true;

	if (a.code === undefined) throw Error('Not a chat');
	if (b.code === undefined) throw Error('Not a chat');

	return a.code === b.code || a.code === `${b.code.split(':')[1]}:${b.code.split(':')[0]}`;
};

export default chatMatches;



// WEBPACK FOOTER //
// ./src/user/chatMatches.js